<div class="content-layout fullwidth-basic-normal-scroll">
  <treo-card class="auth-card fullscreen">
    <!-- Form container -->
    <div class="form-container">
      <div class="form">
        <!-- Logo -->

        <!-- Title -->
        <div class="title">Reset your password</div>
        <div class="subtitle">Create a new password for your account</div>

        <!-- Message -->
        <treo-message
          *ngIf="message"
          [appearance]="message.appearance"
          [showIcon]="message.showIcon"
          [type]="message.type"
          [@shake]="message.shake"
        >
          {{ message.content }}
        </treo-message>

        <!-- Reset password form -->
        <form [formGroup]="resetPasswordForm">
          <!-- Password field -->
          <mat-form-field>
            <mat-label>Password</mat-label>
            <input id="password" matInput type="password" [formControlName]="'password'" #passwordField />
            <button
              mat-icon-button
              type="button"
              (click)="
                passwordField.type === 'password' ? (passwordField.type = 'text') : (passwordField.type = 'password')
              "
              tabindex="-1"
              matSuffix
            >
              <mat-icon *ngIf="passwordField.type === 'password'" [svgIcon]="'visibility'"></mat-icon>
              <mat-icon *ngIf="passwordField.type === 'text'" [svgIcon]="'visibility_off'"></mat-icon>
            </button>
            <mat-error> Password is required </mat-error>
          </mat-form-field>

          <!-- Password confirm field -->
          <mat-form-field>
            <mat-label>Password (Confirm)</mat-label>
            <input
              id="password-confirm"
              matInput
              type="password"
              [formControlName]="'confirm_password'"
              #passwordConfirmField
            />
            <button
              mat-icon-button
              type="button"
              (click)="
                passwordConfirmField.type === 'password'
                  ? (passwordConfirmField.type = 'text')
                  : (passwordConfirmField.type = 'password')
              "
              tabindex="-1"
              matSuffix
            >
              <mat-icon *ngIf="passwordConfirmField.type === 'password'" [svgIcon]="'visibility'"></mat-icon>
              <mat-icon *ngIf="passwordConfirmField.type === 'text'" [svgIcon]="'visibility_off'"></mat-icon>
            </button>
            <mat-error *ngIf="resetPasswordForm.get('confirm_password').hasError('required')">
              Password confirmation is required
            </mat-error>
            <mat-error *ngIf="resetPasswordForm.get('confirm_password').hasError('mustMatch')">
              Passwords must match
            </mat-error>
          </mat-form-field>

          <!-- Submit button -->
          <button
            class="submit-button treo-mat-button-large"
            mat-flat-button
            type="submit"
            [color]="'primary'"
            [disabled]="resetPasswordForm.disabled"
            (click)="resetPassword()"
          >
            <span *ngIf="!resetPasswordForm.disabled"> Reset your password </span>
            <mat-progress-spinner
              *ngIf="resetPasswordForm.disabled"
              [diameter]="24"
              [mode]="'indeterminate'"
            ></mat-progress-spinner>
          </button>

          <!-- Form footer -->
          <div class="form-footer">
            <span>Return to</span>
            <a class="link" [routerLink]="['/sign-in']">sign in</a>
          </div>
        </form>
      </div>
    </div>

    <!-- Content container -->
    <div class="content-container">
      <!-- Background - Inline SVG for easy customizations -->
      <svg
        class="background"
        viewBox="0 0 1531 891"
        preserveAspectRatio="xMidYMax slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 182c144.327 47.973 534.462 219.712 440.509 369.87C346.555 702.028 79.877 662.846 0 638V182z"></path>
        <path
          d="M1405 848c-424.366 158.009-437-164-437-272s102-425 563-576v769c-21.333 29.333-63.333 55.667-126 79z"
        ></path>
        <path
          d="M1531 162c-122.914-17.284-377.96 33.191-543.433 206.414C822.095 541.636 797.342 648.75 835.842 731.622c38.5 82.871 198.243 134.841 400.555 92.053C1438.71 780.886 1492.752 775.894 1531 768V162z"
        ></path>
      </svg>

      <div class="content">
        <div class="title">
          <span>We make real estate</span>
          <span>investors better.</span>
        </div>
        <div class="description">
          TermSheet is a real estate workflow platform that brings your deals and data into a single location across
          both web and mobile.
        </div>
        <button class="learn-more-button" (click)="goHome()" type="button" mat-stroked-button>Learn more</button>
      </div>
    </div>
  </treo-card>
</div>
